import { Link, Text } from "@primer/react";
import "./SampleRecordAction.css";

export function SampleRecordAction({ children, disabled = false, onSelect }) {
  return <Text as="div" className="sample-record-action">
    <span>or</span>
    <Link as="button" type="button" disabled={disabled} onClick={onSelect}>{children}</Link>
  </Text>;
}
